export const COOKIE_TERMS_LABEL = 'wakame-terms';
export const COOKIE_LANGUAGE_LABEL = 'wakame-language';